module.exports = __webpack_public_path__ + "img/text.b7cce152.png";